import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Select,
  CircularProgress,
  Box
} from '@mui/material';
import {
  FormPageContainer,
  FormHeader,
  FormSubHeader,
  StyledForm,
  SubmitButton
} from './PersonalDetailsForm.styles';

export default function PersonalDetailsForm({ formData, handleChange, handleSubmit, isSubmitting }) {
  return (
    <FormPageContainer>
      <FormHeader variant="h4" component="h1">Will & Testament Creator</FormHeader>
      <FormSubHeader variant="h5" component="h2">Step 1: Personal Details</FormSubHeader>
      <StyledForm component="form" onSubmit={handleSubmit} noValidate>
        <FormControl fullWidth required sx={{ padding: '12px' }}>
          <InputLabel id="title-label" sx={{ padding: '12px' }}>Title</InputLabel>
          <Select
            labelId="title-label"
            id="title"
            name="title"
            value={formData.title}
            label="Title"
            onChange={handleChange}
          >
            <MenuItem value=""><em>Select</em></MenuItem>
            <MenuItem value="Mr">Mr</MenuItem>
            <MenuItem value="Mrs">Mrs</MenuItem>
            <MenuItem value="Ms">Ms</MenuItem>
            <MenuItem value="Dr">Dr</MenuItem>
            <MenuItem value="Prof">Prof</MenuItem>
          </Select>
        </FormControl>

        <TextField
          id="firstName"
          name="firstName"
          label="First Name(s)"
          value={formData.firstName}
          onChange={handleChange}
          required
          fullWidth
          sx={{ padding: '12px' }}
        />

        <TextField
          id="lastName"
          name="lastName"
          label="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          required
          fullWidth
          sx={{ padding: '12px' }}
        />

        <TextField
          id="email"
          name="email"
          label="Email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          fullWidth
          sx={{ padding: '12px' }}
        />

        <TextField
          id="cellphone"
          name="cellphone"
          label="Cellphone Number"
          type="tel"
          value={formData.cellphone}
          onChange={handleChange}
          required
          fullWidth
          sx={{ padding: '12px' }}
        />

        <TextField
          id="idNumber"
          name="idNumber"
          label="ID Number"
          value={formData.idNumber}
          onChange={handleChange}
          required
          fullWidth
          sx={{ padding: '12px' }}
          InputProps={{
            readOnly: true, // Make ID read-only as it's pre-filled from auth
          }}
          helperText="Pre-filled from verification"
        />

        <TextField
          id="address"
          name="address"
          label="Address"
          value={formData.address}
          onChange={handleChange}
          required
          fullWidth
          multiline
          sx={{ padding: '12px' }}
          rows={3}
        />

        <SubmitButton
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
            onClick={(e) => {handleSubmit(e)}}
        >
          {isSubmitting ? 'Processing...' : 'Next'}
        </SubmitButton>
      </StyledForm>
    </FormPageContainer>
  );
} 